var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkBasicDialog',{ref:"webSocketDialog",attrs:{"width":"sm"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('Components.sentences.youGotMail'))+" ")]},proxy:true},{key:"content",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('Components.sentences.youGotMail'))+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }